function loadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.src = src;
  });
}
function normalizeSize(size, step) {
  return Math.ceil(size / step) * step;
}
export {
  loadImage,
  normalizeSize
};
//# sourceMappingURL=utils.js.map
